function nw_zepto_app_personalizer_warning() {
setTimeout(() => {
    const personalizer = document.querySelector('.product-info .shopify-app-block .product-personalizer');
    if (personalizer && personalizer.innerHTML.trim() === '') {
    const warning = document.createElement('div');
    warning.style.backgroundColor = '#fdb54a';
    warning.style.borderRadius = '10px';
    warning.style.padding = '1rem';
    warning.style.marginTop = '1.25rem';
    warning.innerHTML = '<p>The personalisation tool isn’t supported by your browser, please update it to order online. You can also order by calling us on 0333 222 6619, or by using our Live Chat!</p>';
    personalizer.appendChild(warning);
    }
}, 3000);
}
document.addEventListener('DOMContentLoaded', function () {
nw_zepto_app_personalizer_warning();
});